import { render, staticRenderFns } from "./ChangeCategory.vue?vue&type=template&id=20d34f4c&scoped=true&"
import script from "./ChangeCategory.vue?vue&type=script&lang=js&"
export * from "./ChangeCategory.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCategory.vue?vue&type=style&index=0&id=20d34f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d34f4c",
  null
  
)

export default component.exports